var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "company-introduction-content-wrap",
    class: !_vm.expanded && !_vm.showsMore ? undefined : 'pb-0'
  }, [_c('div', _vm._b({
    ref: "content-box",
    staticClass: "company-introduction-content",
    class: {
      showsMore: _vm.showsMore,
      expanded: _vm.expanded
    }
  }, 'div', {
    style: _vm.style
  }, false), [_c('p', {
    staticClass: "page-text grey--text line-height-15",
    domProps: {
      "innerHTML": _vm._s(_vm.content)
    }
  })]), _c('v-fade-transition', [!_vm.expanded && !_vm.showsMore ? _c('v-btn', {
    staticStyle: {
      "z-index": "1"
    },
    attrs: {
      "absolute": "",
      "right": "",
      "bottom": "",
      "small": "",
      "outlined": "",
      "color": "grey-d"
    },
    on: {
      "click": function click($event) {
        _vm.showsMore = true;
      }
    }
  }, [_c('span', {
    staticClass: "grey--text"
  }, [_vm._v("더보기")])]) : _vm._e()], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }